module.exports = __webpack_public_path__ + "static/media/8OLA20.53f64c4a.jpg";